import React from 'react';
import { PriceAlert } from '../components/PriceAlert';
import { Hero } from '../components/Hero';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1381">
      <PriceAlert data-id="element-1382" />
      <Hero data-id="element-1383" />
      <Testimonial data-id="element-1384" />
      <ProblemSolution data-id="element-1385" />
      <ValueStack data-id="element-1386" />
      <ModuleBreakdown data-id="element-1387" />
      <Guarantee data-id="element-1388" />
      <PricingSection data-id="element-1389" />
      <Footer data-id="element-1390" />
      <RecentPurchaseToast data-id="element-1391" />
    </div>;
}